import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import Tooltip from 'scoreboard/components/tooltip'
import { checkboxTransform } from 'checked-input-wrapper'
import SyncedItemTooltip from 'scoreboard/components/synced-item-tooltip'
import { isV6 } from 'scoreboard/components/version'

/**
 * Adds update thresholds checkbox to the default principal panel
 */
var ScorecardsUpdatersPanel = PrincipalPanel.extend({

	initialize: function(options) {
		let columnHeaders
		if (isV6()) {
			columnHeaders = [
				i18n.get('common.name'),
				i18n.get('scorecards.overview.updater.canUpdate'),
				i18n.get('common.delete')]
		}
		let superOptions = _.extend({ columnHeaders }, options)
		PrincipalPanel.prototype.initialize.call(this, superOptions)
	},

	render: function() {
		PrincipalPanel.prototype.render.apply(this, arguments)
		this.$('th.principal-update-cell')
			.text(i18n.get('scorecards.overview.updater.canUpdate'))
		return this
	},

	renderPrincipal: function (principal) {
		var html = PrincipalPanel.prototype.renderPrincipal.apply(this, arguments)
		const checked = principal.updateThresholds ? 'checked' : ''
		const disabled = principal.fromTemplate ? 'disabled' : ''
		const checkbox = checkboxTransform(`<input type="checkbox" ${checked} ${disabled}/>`)
		html = $(html)
		html.find('.principal-update-cell')
			.removeClass('is-not-displayed')
			.html(`<label>${checkbox}</label>`)

		if (principal.fromTemplate) {
			html.attr('data-from-template', true)

			this.syncedItemTooltip = new SyncedItemTooltip({
				el: html.find('.table-actions-cell'),
				attachTo: html.find('.delete'),
				itemType: i18n.get('common.updater')
			}).render()

			// Show an info tooltip if the checkbox is clicked
			let self = this
			html.find('.principal-update-cell svg').on('click', function () {
				self.removeDisabledTooltip()
				self.disabledTooltip = new Tooltip({
					attachTo: this,
					placement: 'above',
					arrow: 'center',
					content: i18n.get('template.synced.cantChange',
						i18n.get('common.updater').toLowerCase())
				}).render()
			})
		}

		return html
	},

	readPrincipalOptionsFromDomRow: function (row, principal) {
		if (row.find('[type=checkbox]')[0].checked) {
			principal.updateThresholds = true
		}

		if (row.data().fromTemplate) {
			principal.fromTemplate = true
		}
	},

	removeDisabledTooltip: function () {
		this.disabledTooltip && this.disabledTooltip.remove()
		delete this.disabledTooltip
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeDisabledTooltip()
		_.invokeMap([this.syncedItemTooltip], 'remove')
	}
})

export default ScorecardsUpdatersPanel
ScorecardsUpdatersPanel.__filename__ = 'scorecards/edit/scorecards-updaters-panel.js'
